var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8186 4.01553C17.8306 4.19053 17.8306 4.36553 17.8306 4.54215C17.8306 9.9236 13.7339 16.1301 6.24274 16.1301V16.1268C4.02984 16.1301 1.8629 15.4962 0 14.301C0.321774 14.3397 0.645161 14.3591 0.969355 14.3599C2.80323 14.3615 4.58468 13.7462 6.02742 12.6131C4.28468 12.5801 2.75645 11.4438 2.22258 9.78489C2.83306 9.90263 3.4621 9.87844 4.06129 9.71473C2.16129 9.33086 0.794355 7.6615 0.794355 5.72279C0.794355 5.70505 0.794355 5.68812 0.794355 5.67118C1.36048 5.9865 1.99435 6.1615 2.64274 6.18086C0.853226 4.98489 0.301613 2.60424 1.38226 0.742954C3.45 3.28731 6.50081 4.83408 9.77581 4.99779C9.44758 3.58328 9.89597 2.10102 10.954 1.10666C12.5944 -0.435272 15.1742 -0.35624 16.7161 1.28328C17.6282 1.10344 18.5024 0.76876 19.3024 0.294567C18.9984 1.23731 18.3621 2.03812 17.5121 2.54699C18.3194 2.45182 19.1081 2.2357 19.8508 1.90586C19.304 2.72521 18.6153 3.43892 17.8186 4.01553Z",
    fill: "#8B94B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdIcon);
export default __webpack_public_path__ + "static/media/BirdIcon.14acb38d0d095c2ff1704b0b7fd53ee0.svg";
export { ForwardRef as ReactComponent };